import { gql, TypedDocumentNode } from "@apollo/client";

import {
  RedeemCreditsMutation,
  RedeemCreditsMutationVariables,
} from "./Referral.generated";

export const REDEEM_CREDITS: TypedDocumentNode<
  RedeemCreditsMutation,
  RedeemCreditsMutationVariables
> = gql`
  mutation RedeemCredits(
    $amountCents: Int!
    $recipientName: String
    $recipientEmail: String
  ) {
    redeemCredits(
      amountCents: $amountCents
      recipientName: $recipientName
      recipientEmail: $recipientEmail
    ) {
      success
      message
      remainingBalanceCents
    }
  }
`;
